import * as actionTypes from './actionTypes'
import { getPreviewDynamicData } from '../../lib/projectAxios'
import { doProcessRules } from '../../lib/processPortalRules'
import { processSFAutoTrigger } from './processSFAutoTrigger'
import { processButtonAction } from './processButtonAction'

const DEFAULT_OTP_SESSION_DURATION_MINUTES = 120

export const processPageOnLoad = () => (dispatch) => dispatch({ type: actionTypes.PROCESS_PAGE_ON_LOAD })

export const processSetSessLeftTime = (isPreview) => (dispatch, getState) => {
  let intervalID = null
  const state = getState()
  const isUseOnSessionExpireEvent = state.getIn(
    ['project', 'Settings', 'ui', 'events', 'isUseOnSessionExpireEvent'],
    false
  )
  let smartVSessionTime = parseInt(state.getIn(['project', 'Settings', 'SmartV', 'smartVSessionTime'], 120), 10)
  if (Number.isNaN(smartVSessionTime)) {
    smartVSessionTime = 120
  }

  const updateLeftSessionTime = () => {
    const state = getState()
    const onSessionExpireAction = state.getIn(['project', 'Settings', 'ui', 'events', 'onSessionExpire'], false)
    let data = getPreviewDynamicData()
    let ftSessLeftTime = data?.svParams?.ftSessLeftTime || 0

    if (ftSessLeftTime && isPreview) {
      let left = Number(
        (parseInt(ftSessLeftTime, 10) + smartVSessionTime * 60 * 1000 - new Date().getTime()) / 1000
      ).toFixed(0)
      if (left <= 0) {
        left = 0
        if (isUseOnSessionExpireEvent && onSessionExpireAction) {
          let haveSession = Boolean(data?.user)
          const isLocalLogout = getState().getIn(['isLocalLogout'], false)
          if (isLocalLogout) {
            haveSession = false
          }
          if (haveSession) {
            dispatch(processButtonAction(onSessionExpireAction, 'smartV-session-expire', false, 0))
          }
        }
      }
      let prevTime = getState().getIn(['params', 'ftSessLeftTime'], 0)
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: getState().setIn(['params', 'ftSessLeftTime'], left),
        },
      })
      if (prevTime !== left) {
        let state = getState()
        state = doProcessRules(state, false, ['ftSessLeftTime'], [], [['ftSessLeftTime']], false)
        dispatch({
          type: actionTypes.SET_STORE,
          payload: {
            store: state,
          },
        })
        dispatch(processSFAutoTrigger())
      }
      let sleep = 15
      if (window.updateLeftSessionTime) {
        clearTimeout(window.updateLeftSessionTime)
      }
      if (60 > left) {
        sleep = 6
      }
      window.updateLeftSessionTime = setTimeout(function () {
        updateLeftSessionTime()
      }, sleep * 1000)
    } else if (isPreview) {
      if (window.updateLeftSessionTime) {
        clearTimeout(window.updateLeftSessionTime)
      }
      window.updateLeftSessionTime = setTimeout(function () {
        updateLeftSessionTime()
      }, 5 * 1000)
    }
  }

  if (!getState().getIn(['project', 'isPublic'], false)) {
    updateLeftSessionTime()
  }

  return () => {
    if (window.updateLeftSessionTime) {
      clearTimeout(window.updateLeftSessionTime)
    }
  }
}

export const processSetOtpSessionLeftTime = (isPreview) => (dispatch, getState) => {
  const state = getState()
  const isOtpEnabled = state.getIn(['project', 'Settings', 'otpSettings', 'enabled'], false)

  if (!isOtpEnabled) {
    return
  }

  const updateOtpSessionRemainingTime = () => {
    const state = getState()

    const ftOtpSessionStartTimestamp = state.getIn(['params', 'ftOtpSessionStartTimestamp'])
    let ftOtpSessionDurationMinutes = state.getIn(
      ['params', 'ftOtpSessionDurationMinutes'],
      DEFAULT_OTP_SESSION_DURATION_MINUTES
    )

    if (Number.isNaN(ftOtpSessionDurationMinutes)) {
      ftOtpSessionDurationMinutes = DEFAULT_OTP_SESSION_DURATION_MINUTES
    }

    if (ftOtpSessionStartTimestamp && isPreview) {
      let remainingTimeSeconds = Number(
        (parseInt(ftOtpSessionStartTimestamp, 10) + ftOtpSessionDurationMinutes * 60 * 1000 - Date.now()) / 1000
      ).toFixed(0)

      if (remainingTimeSeconds <= 0) {
        remainingTimeSeconds = 0
      }

      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state.setIn(['params', 'ftOtpSessionRemainingTimeSeconds'], remainingTimeSeconds),
        },
      })

      if (window.updateOtpSessionRemainingTime) {
        clearTimeout(window.updateOtpSessionRemainingTime)
      }

      const delay = remainingTimeSeconds <= 60 ? 6 : 15

      window.updateOtpSessionRemainingTime = setTimeout(() => {
        updateOtpSessionRemainingTime()
      }, delay * 1000)
    } else if (isPreview) {
      if (window.updateOtpSessionRemainingTime) {
        clearTimeout(window.updateOtpSessionRemainingTime)
      }

      window.updateOtpSessionRemainingTime = setTimeout(() => {
        updateOtpSessionRemainingTime()
      }, 500)
    }
  }

  updateOtpSessionRemainingTime()

  return () => {
    if (window.updateOtpSessionRemainingTime) {
      clearTimeout(window.updateOtpSessionRemainingTime)
    }
  }
}
